import {
    Text3,
    Text2,
    IconWarningRegular,
    Stack,
    Text6,
    IconChevronLeftRegular,
    NavigationBar,
    skinVars,
    useDialog,
    IconShieldCrossRegular,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';
import navigateParams from '../../../../../utils/navigation/navigateParams';
import OTPVerification from '../../../../../components/OTPVerification';
import { generateOtpCookie, sendEscalationOTP } from '../../../../../services/EscalationService';
import { setInfoError } from '../../../../../utils/dataTransformation/errorMesssages';
import { AxiosError } from 'axios';
import { isBrowser } from 'react-device-detect';
import { TrackingEvents } from '../../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';

const ContactInfoVerifiedOTP: React.FC = () => {
    const [showError, setShowError] = useState<boolean>(false);
    const [error, setError] = useState<number | undefined>(401);
    const { t } = useTranslation();
    const [params] = useSearchParams();
    const contact = params.get('contact')!;
    const { trackingScreenView } = new TrackingEvents();
    const navigate = useNavigate();
    const [otp, setOtp] = useState('');
    const [incorrectCode, setIncorrectCode] = useState<boolean>(false);
    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);
    const { dialog } = useDialog();

    const sendToNative = (url: string, description: string, type: string, title?: string, err?: any) => {
        const storage = {};
        const feedbackData = {
            stateFeedback: description,
            err: err,
        };
        const queryParams = {
            state: description,
            errorCode: err ? err.id : '',
            title: description === 'ERROR' ? 'Algo ha fallado' : t('contactVerificationSuccessTitle'),
            subtitle: description === 'ERROR' ? t('profileFeedbackErrorSubtitle') : t('feedbackSuccessSubtitle'),
        };
        if (navigateParams(type, url, queryParams, storage, title)) {
            navigate(url, { state: feedbackData });
        }
    };

    const escalationOTPSend = () => {
        const data: any = { contact: contact };
        sendEscalationOTP(data)
            .then(() => {})
            .catch((error: any) => {
                console.error(setInfoError(error));
                sendToNative('/escalation/otp/feedback', 'ERROR', 'feedback-error', '', setInfoError(error));
            });
    };

    const escalationOTPValidate = () => {
        generateOtpCookie(otp)
            .then((response: any) => {
                if (response.status === 200) {
                    sendToNative('/escalation/otp/feedback', 'SUCCESS', 'feedback-success', '', setInfoError(error));
                } else if (response.status === 400) {
                    setIncorrectCode(true);
                    setError(response?.status);
                    setShowError(true);
                }
            })
            .catch((error: AxiosError) => {
                if ([401, 403].includes(Number(error.response?.status))) {
                    const { id } = setInfoError(error);
                    dialog({
                        icon: <IconWarningRegular color={skinVars.colors.feedbackErrorBackground} size={64} />,
                        title: t('profileFeedbackErrorTitle'),
                        message: (() => {
                            return (
                                <Stack space={16}>
                                    <Text3 light color={skinVars.colors.borderHigh}>
                                        {t('errorValidateOTP')}
                                    </Text3>
                                    {id && (
                                        <Text3 light color={skinVars.colors.borderHigh}>
                                            {`${t('codeError')} ${id}`}
                                        </Text3>
                                    )}
                                </Stack>
                            );
                        })() as any,
                        onAccept() {},
                        acceptText: t('buttonUnderstoodFeedback'),
                    });
                } else {
                    sendToNative('/escalation/otp/feedback', 'ERROR', 'feedback-error', '', setInfoError(error));
                }
            });
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (windowWidth >= 1024) {
        return (
            <div className='desktop-contact-info-verified'>
                <div className='desktop-contact-info-verified__header-navigationBar'>
                    <NavigationBar isInverse={true} title={''} />
                </div>
                <div className='desktop-contact-info-verified__left'>
                    <div className='desktop-contact-info-verified__left__icon'>
                        <IconShieldCrossRegular size={64} color={skinVars.colors.brand}></IconShieldCrossRegular>
                    </div>
                    <div className='desktop-contact-info-verified__left__title'>
                        <Text6 color={skinVars.colors.textPrimary}>{t('otpFlowTitle')}</Text6>
                    </div>
                    <div className='desktop-contact-info-verified__left__subtitle'>
                        <Text3 regular color={skinVars.colors.textSecondary}>
                            {t('otpFlowSubtitle')}
                        </Text3>
                    </div>
                </div>
                <div className='desktop-contact-info-verified__right'>
                    <div className='contact-info-verified-otp'>
                        <div className='contact-info-verified-otp__header-return'>
                            <div
                                className='contact-info-verified-otp__header-return-icon'
                                onClick={() => {
                                    navigate(-1);
                                }}
                            >
                                <IconChevronLeftRegular color={skinVars.colors.textLink} size={20} />
                            </div>
                            <Text2 medium color={skinVars.colors.textLink}>
                                {t('returnResponsive')}
                            </Text2>
                        </div>
                        <OTPVerification
                            title={t('contactVerifiedOTP')}
                            subtitle1={''}
                            subtitle2={''}
                            contact={''}
                            handleSendAgain={escalationOTPSend}
                            setOTPValue={setOtp}
                            incorrectCode={incorrectCode}
                            handleButtonContinue={escalationOTPValidate}
                        ></OTPVerification>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className='contact-info-verified-otp'>
                {isBrowser && (
                    <div className='c-customer-agreement-navigationBar'>
                        <NavigationBar
                            isInverse={true}
                            onBack={() => {
                                navigate(-1);
                            }}
                            title={'Verificar móvil de contacto'}
                        />
                    </div>
                )}
                <OTPVerification
                    title={t('contactVerifiedOTP')}
                    subtitle1={''}
                    subtitle2={''}
                    contact={''}
                    handleSendAgain={escalationOTPSend}
                    setOTPValue={setOtp}
                    incorrectCode={incorrectCode}
                    handleButtonContinue={escalationOTPValidate}
                ></OTPVerification>
            </div>
        );
    }
};

export default ContactInfoVerifiedOTP;
